import { gql } from '@apollo/client';

const UPDATE_CLINIC_NOTIFICATIONS_MUTATION = gql`
  mutation updateClinicNotifications($input: UpdateClinicNotificationsInput!) {
    updateClinicNotifications(input: $input) {
      isSuccess
      message
    }
  }
`;

export default UPDATE_CLINIC_NOTIFICATIONS_MUTATION;
